import React from 'react';
import FilterCenterFocusIcon from '@mui/icons-material/FilterCenterFocus';

import { useAppMonitor } from '../../../monitor';
import { focusCameraOnSelectedObjects } from '../../../three/ThreeJsSceneActions';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export default function FocusButton() {
  const monitor = useAppMonitor();

  return (
    <ToolbarIconButton
      clickableDuringPicking
      icon={<FilterCenterFocusIcon />}
      title="Focus Camera to Selected Item(s) (Ctrl + .)"
      onClick={() => {
        focusCameraOnSelectedObjects();
        monitor.recordInteraction('Camera Focused to Selected Object');
      }}
    />
  );
}
